// extracted by mini-css-extract-plugin
module.exports = {"originSvgWrapper":"style_originSvgWrapper__1qAgF"};